var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2FA4DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.614 5.154h16.772m-16.772 0c-.87 0-1.305 0-1.637.15a1.48 1.48 0 00-.679.606c-.17.296-.17.684-.17 1.46v7.2c0 1.55 0 2.325.34 2.918a2.96 2.96 0 001.357 1.21C6.488 19 7.358 19 9.094 19h11.812c1.735 0 2.603 0 3.268-.302a2.973 2.973 0 001.358-1.21c.34-.591.34-1.365.34-2.913v-7.22c0-.767 0-1.152-.17-1.447a1.48 1.48 0 00-.679-.605c-.332-.15-.767-.15-1.637-.15m-16.772 0H4.09c-1.318 0-1.977 0-2.351-.204a1.459 1.459 0 01-.573-.557 1.257 1.257 0 01-.16-.742c.037-.39.43-.862 1.216-1.81.228-.272.341-.41.481-.515.185-.138.404-.238.642-.288C3.522 1 3.71 1 4.093 1h21.812c.382 0 .572 0 .749.037.236.05.456.15.643.288.14.106.253.241.481.515.786.946 1.179 1.42 1.216 1.81.025.256-.03.513-.16.742a1.46 1.46 0 01-.573.557c-.374.205-1.036.205-2.354.205h-2.52m-11.493 6.923h6.212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default ForwardRef;